<div class="open-header-user-menu" *ngIf="isLoggedIn && !isLoading">
  <button mat-icon-button class="open-header-user-menu-avatar" aria-label="Menu" [matMenuTriggerFor]="user_menu">
    <span class="open-header-user-menu-initials" *ngIf="userInitials">{{ userInitials }}</span>
    <span class="open-header-user-menu-initials" *ngIf="!userInitials">
      <mat-icon class="person material-icons-outlined" aria-hidden="true"></mat-icon>
    </span>
  </button>
  <mat-menu #user_menu="matMenu" xPosition="before">
    <button mat-menu-item (click)="goToDashboard()">
      <mat-icon class="home material-icons-outlined" aria-hidden="true"></mat-icon>
      <span>Dashboard</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon class="logout" aria-hidden="true"></mat-icon>
      <span>Log out</span>
    </button>
  </mat-menu>
</div>
